import React from 'react';

const ImageGenerationIndicator = () => {
  return (
    <div className="relative w-[300px] max-w-[85vw] overflow-hidden rounded-2xl border border-gray-200/80 bg-gradient-to-br from-slate-100 via-white to-slate-200 shadow-sm dark:border-gray-700/80 dark:from-gray-800 dark:via-gray-900 dark:to-gray-800">
      <div className="relative h-[220px] w-full">
        <div className="absolute inset-0 image-gen-glow" />
        <div className="absolute -left-1/2 top-0 h-full w-1/2 image-gen-sheen" />
        <div className="absolute inset-x-4 bottom-4 flex items-center justify-between rounded-xl bg-black/45 px-3 py-2 text-white backdrop-blur-sm">
          <span className="text-sm font-medium tracking-wide">Generating image...</span>
          <span className="image-gen-spinner" />
        </div>
      </div>
    </div>
  );
};

export default ImageGenerationIndicator;
